export default "__VITE_ASSET__CgLXWvGV__$_?inline__"